import React, { memo } from 'react';
import { injectIntl } from 'react-intl';
import home from './home.svg';

const HomeIcon = props => <img className="" src={home} alt={props.intl.formatMessage({ id: 'icon.home' })} />;

export default injectIntl(memo(HomeIcon));
